<template>
  <div>
    <div class="row m-4 mt-0 mb-0">
      <div class="col-sm-12">
        <div class="card card-body mb-0">
          <div class="row">
            <div class="form-group col-sm-12">
              <ul class="navbar-nav overflow-auto flex-row gap-4" >
                <li v-for="(value, tab) in Tabs" :key="tab" class="nav-item nav-item-spaced d-lg-block text-nowrap" >
                  <a href="#" @click.prevent="selectTab(value)" class="nav-link tab" :class="{'active': activeTabName === value}">{{ helper.trans(`labels.${tab}`) }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <Providers v-if="activeTabName === Tabs.providers"></Providers>
      <Cascades v-if="activeTabName === Tabs.cascades"></Cascades>
    </div>
  </div>
</template>
<script lang="ts">
import {defineComponent, toRefs, reactive} from 'vue'
import {helper} from "@/service/CommonHelper";
import ManualPriorities from "@/views/ManualPriorities.vue";
import TrafficGroups from "@/views/TrafficGroups.vue";
import router from "@/router";
import {useRoute} from "vue-router";
import MerchantStores from "@/views/MerchantStores.vue";
import AdditionalRewardSettings from "@/views/AdditionalRewardSettings.vue";
import Providers from "@/views/Providers.vue";
import Cascades from "@/views/Cascades.vue";

enum Tabs {
  providers = 'providers',
  cascades = 'cascades',

}

export default defineComponent({
  components: {
    Cascades,
    Providers,
    AdditionalRewardSettings,
    MerchantStores,
    TrafficGroups,
    ManualPriorities
  },
  setup() {
    const route = useRoute()
    let activeTabName = (route.params.tab ?? Tabs.providers) as Tabs
    if (!Object.keys(Tabs).includes(activeTabName)) {
      activeTabName = Tabs.providers
    }
    const state = reactive({
      activeTabName
    });

    const selectTab = async (value: string) => {
      router.push(`/admin/aggregator/${value}`)
      state.activeTabName = value as Tabs
    }

    return {
      ...toRefs(state),
      helper,
      Tabs,
      selectTab
    }
  }
})
</script>
